import ZoomButtons from '@components/toolbar/ZoomButtons'
import { useZoomContext } from '@routes/Panorama/ZoomContext'

function PanoramaZoomButtons() {
  const { zoomOut, zoomIn, zoomState } = useZoomContext()

  return (
    <ZoomButtons
      zoomIn={zoomIn}
      zoomOut={zoomOut}
      zoomInDisabled={zoomState === 'MIN'}
      zoomOutDisabled={zoomState === 'MAX'}
    />
  )
}

export default PanoramaZoomButtons